const UseAgreement = () => import(/* webpackChunkName: "group-agreement" */ '@/components/agreements/use-agreement')
const TermsOfService = () => import(/* webpackChunkName: "group-agreement" */ '@/components/agreements/terms-of-service')
const PrivacyPolicy = () => import(/* webpackChunkName: "group-agreement" */ '@/components/agreements/privacy-policy')

export default {
  path: '/use-agreement',
  component: UseAgreement,

  children: [
    {
      path: '/privacy',
      component: PrivacyPolicy
    },
    {
      path: '/terms',
      component: TermsOfService
    },
    {
      path: '',
      component: TermsOfService
    }
  ]
}
